export default "__VITE_ASSET__cae7e805__"